// Utils
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

// Types
import type { SharedEvent } from './types';

type State = {
    sharedEvent: ?SharedEvent
};

const selectSharedEvent = (state: State) => state.sharedEvent;

const makeSelectSharedEventValue = (field: string) =>
    createDeepEqualSelector(
        selectSharedEvent,
        sharedEventState => sharedEventState && sharedEventState[field]
    );

export { makeSelectSharedEventValue };
